import { defineComponent as _defineComponent } from 'vue'
import { StyleValue } from 'vue/types/jsx';
import ModalItem from '../ModalItem/ModalItem.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewImg',
  props: {
    imgStyle: null
  },
  setup(__props: any) {

const props = __props as {
    imgStyle?: StyleValue ;
};




return { __sfc: true,props, ModalItem }
}

})